import Select            from 'react-select'
import {useState}        from 'react'

export default function useSelectMulti({initialState, optionsState, isClearable,position,label, isDisabled}) {
    const   [value, setValue] = useState(initialState ? initialState : []),
            selectMulti = (
                <Select
                    value             = {value ? optionsState.filter(element => value.includes(element.value)) : []}
                    onChange          = {e => setValue(e ? e.map(({value}) => value) : [])}
                    isClearable       = {isClearable ? isClearable : false}
                    placeholder       = {label?label:'Seleccione'}
                    getOptionLabel    = {({label}) => label}
                    getOptionValue    = {({value}) => value}
                    options           = {optionsState}
                    closeMenuOnSelect = {false}
                    isMulti
                    menuPlacement={position ? position : 'bottom'}
                    isDisabled={isDisabled ? isDisabled : false}
                />
            )
    return {
        get:    value,
        select: selectMulti,
        set:    setValue
    }
}
